import { FETCH_WIDGETS_FAILED } from '../../types'

export default function createFetchWidgetsFailAction(error) {
  return { type: FETCH_WIDGETS_FAILED, payload: { payload: error } }
}
